import React from 'react';
import classNames from 'classnames';
import Balancer from 'react-wrap-balancer';

interface TextBalancerProps {
  children?: React.ReactNode;
  ratio?: number;
  preferNative?: boolean;
  className?: string;
  as?: keyof JSX.IntrinsicElements;
  dangerouslySetInnerHTML?: {
    __html: string;
  };
}

const TextBalancer = ({
  className,
  as: Element = 'p',
  ...props
}: TextBalancerProps) => {
  return (
    <Element className={classNames(className)}>
      <Balancer {...props} />
    </Element>
  );
};

export default TextBalancer;
